/*
 * ⚠️ `100%`, А НЕ `100vh`. Этот экран роутер показывает КАК `defaultPendingComponent`, то есть
 * отдельно для каждого ожидающего маршрута — и почти всегда это дочерний маршрут, то есть ВНУТРИ
 * оболочки, под шапкой. С `100vh` он требовал целый экран там, где ему отведён экран минус шапка, и
 * при каждом переходе на ленивый чанк выдавал 96 пикселей лишней высоты: полоса прокрутки мигала, а
 * логотип уезжал ниже центра. На мобильных было хуже — там `100vh` больше `100dvh`.
 *
 * Проценту есть от чего считаться благодаря цепочке высот в `reset.css`; при холодном старте, когда
 * этот экран рендерится прямо в точке монтирования, он по-прежнему занимает весь экран.
 */
.root {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: var(--bg);

  animation: 0.34s var(--ease-out) both;
  /* global(): иначе имя захешируется и анимация не сыграет — см. shared/styles/animations.css */
  animation-name: global(scene-in);
}

/* Та же плитка, что в шапке и на экране входа (макет, строка 120). */
.logo {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: var(--accent);
  color: var(--on-accent);
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: 17px;

  animation: 1.6s ease-in-out infinite;
  animation-name: breathe;
}

/* Локальный keyframe: объявление и ссылка хешируются согласованно, `global()` тут не нужен. */
@keyframes breathe {
  50% {
    opacity: 0.45;
  }
}

.label {
  font-size: 12.5px;
  color: var(--ink-3);
}
